import { OrderDirection } from "@goodfill/domain-properties";
import { Button, Flex } from "@goodfill/ui-components";
import { useMemo } from "react";
import "./CreateOrderActions.scss";

interface Props {
  isCreatingOrder: boolean;
  onClickModify: () => void;
  onClickCallToAction: () => void;
  onClickCancel: () => void;
  orderDirection: OrderDirection;
  showOrderPreview: boolean;
  isDisabled: boolean;
}

export const CreateOrderActions: React.FC<Props> = (props) => {
  const {
    isCreatingOrder,
    onClickModify,
    onClickCallToAction,
    onClickCancel,
    orderDirection,
    showOrderPreview,
    isDisabled,
  } = props;

  const isOrderPreview = showOrderPreview;

  const { callToActionLabel, callToActionTestId } = useMemo(() => {
    if (showOrderPreview) {
      if (orderDirection === OrderDirection.Buy) {
        return {
          callToActionTestId: "buy",
          callToActionLabel: "Buy",
        };
      }
      if (orderDirection === OrderDirection.Sell) {
        return {
          callToActionTestId: "sell",
          callToActionLabel: "Sell",
        };
      }
    }

    return {
      callToActionLabel: "Preview Order",
      callToActionTestId: "preview-order",
    };
  }, [orderDirection, showOrderPreview]);

  return (
    <>
      <Flex direction="row" justify="center" verticalMargin={2}>
        <Flex justify="center" direction="col">
          <Button
            fill
            id={callToActionTestId}
            data-testid={callToActionTestId}
            disabled={isDisabled || isCreatingOrder}
            onClick={onClickCallToAction}
            loading={isCreatingOrder}
            primaryGradient={true}
            className="preview-order-btn px-16 py-3 w-80"
          >
            {callToActionLabel}
          </Button>
          {isOrderPreview ? (
            <Flex direction="row" gap={6} items="center" verticalMargin={2}>
              <Button
                fill
                size="small"
                red={true}
                onClick={onClickCancel}
                data-testid="cancel"
                className="preview-order-btn px-3 py-3"
              >
                Cancel
              </Button>
              <Button
                fill
                primary={true}
                size="small"
                onClick={onClickModify}
                data-testid="modify"
                className="preview-order-btn px-3 py-3"
              >
                Modify
              </Button>
            </Flex>
          ) : null}
        </Flex>
      </Flex>
      {!showOrderPreview ? <Flex width={28} justify="center" /> : null}
    </>
  );
};
